import type { CellData as RootCellData } from '../types';

import type { getCellTemplate } from './utils';

export const kind = 'date-cell' as const;

type Lang = 'en-US' | 'en-GB' | 'en-CA';

export interface DateCellData extends RootCellData<typeof kind, Date | null> {
  error: string | null;
  lang: Lang;
}

export type DateCell = ReturnType<typeof getCellTemplate>;
